export const AtAGlance = ({ content }) => <section className="at-a-glance shell" aria-labelledby="at-a-glance-title" data-testid="strategy-at-a-glance">
  <p className="at-a-glance-label" id="at-a-glance-title" data-testid="at-a-glance-label">At a Glance</p>
  <div className="at-a-glance-thesis-wrap"><span data-testid="at-a-glance-thesis-label">{content.thesisLabel ?? "Thesis"}</span><p className="at-a-glance-thesis" data-testid="at-a-glance-thesis">{content.thesis}</p></div>
  <div className="at-a-glance-grid" data-testid="at-a-glance-briefing-grid">
    <article data-testid="at-a-glance-problem">
      <p className="at-a-glance-index">01</p>
      <h2 data-testid="at-a-glance-problem-label">{content.problemLabel ?? "The Problem"}</h2>
      <p data-testid="at-a-glance-problem-value">{content.problem}</p>
      {content.problemDetail && <><h2 className="at-a-glance-detail-label" data-testid="at-a-glance-capacity-label">{content.problemDetail.label}</h2><p data-testid="at-a-glance-capacity-value">{content.problemDetail.text}</p></>}
    </article>
    <article data-testid="at-a-glance-framework">
      <p className="at-a-glance-index">02</p>
      <h2 data-testid="at-a-glance-framework-label">{content.frameworkLabel ?? "The Framework"}</h2>
      <p data-testid="at-a-glance-framework-lead">{content.frameworkLead}</p>
      <p className="at-a-glance-dimensions" data-testid="at-a-glance-framework-dimensions"><span>{content.frameworkDimensions[0]}</span><b aria-hidden="true">{content.frameworkOperator ?? "×"}</b><span>{content.frameworkDimensions[1]}</span></p>
      {content.frameworkDetail && <><h2 className="at-a-glance-detail-label" data-testid="at-a-glance-warning-label">{content.frameworkDetail.label}</h2><p data-testid="at-a-glance-warning-value">{content.frameworkDetail.text}</p></>}
    </article>
    <article data-testid="at-a-glance-decision">
      <p className="at-a-glance-index">03</p>
      <h2 data-testid="at-a-glance-decision-label">{content.decisionLabel ?? "The Decision"}</h2>
      <p data-testid="at-a-glance-decision-value">{content.decisionLead}</p>
      {content.decisionsLabel && <h2 className="at-a-glance-detail-label" data-testid="at-a-glance-responses-label">{content.decisionsLabel}</h2>}
      <ul data-testid="at-a-glance-responses">{content.decisions.map((decision, index) => <li key={decision} data-testid={`at-a-glance-response-${index + 1}`}>{decision}</li>)}</ul>
    </article>
  </div>
  <div className="at-a-glance-question" data-testid="at-a-glance-core-question">
    <p data-testid="at-a-glance-question-label">{content.coreQuestionLabel ?? "The Core Question"}</p>
    <strong data-testid="at-a-glance-question-value">{content.coreQuestion}</strong>
  </div>
</section>;

export const GrowthConceptChart = ({ testId }) => <figure className="framework-figure concept-chart" aria-labelledby={`${testId}-title`} data-testid={testId}>
  <div className="framework-figure-heading">
    <span>Figure 01</span>
    <h3 id={`${testId}-title`} data-testid={`${testId}-title`}>Growth Does Not Always Scale With Advantage</h3>
  </div>
  <svg viewBox="0 0 800 520" role="img" aria-labelledby={`${testId}-svg-title ${testId}-svg-description`} data-testid={`${testId}-svg`}>
    <title id={`${testId}-svg-title`}>Conceptual relationship between business growth and competitive advantage strength</title>
    <desc id={`${testId}-svg-description`}>Growth Opportunity continues rising as business scale increases. Competitive Advantage Resilience remains relatively resilient earlier, then may flatten or weaken as scalability constraints become material. The shaded transition band indicates a qualitative scalability pressure zone, not a predetermined threshold.</desc>
    <defs>
      <marker id="axis-arrow" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto"><path d="M0,0 L0,6 L7,3 z" /></marker>
    </defs>
    <rect className="chart-risk-region" x="540" y="64" width="190" height="356" />
    <rect className="chart-pressure-zone" x="475" y="64" width="65" height="356" />
    <path className="chart-axis" d="M92 420 L740 420" markerEnd="url(#axis-arrow)" />
    <path className="chart-axis" d="M92 420 L92 48" markerEnd="url(#axis-arrow)" />
    <text className="chart-axis-label" x="415" y="494">Business Scale / Growth →</text>
    <text className="chart-axis-label" x="28" y="244" transform="rotate(-90 28 244)">Conceptual Index</text>
    <text className="chart-axis-note" x="51" y="244" transform="rotate(-90 51 244)">(relative direction only — not quantitative)</text>
    <path className="chart-demand-line" d="M112 376 C238 334 360 277 478 205 C575 146 660 103 720 76" />
    <path className="chart-advantage-line" d="M112 374 C228 326 340 252 445 197 C470 184 490 177 508 174" />
    <path className="chart-advantage-risk-line" d="M508 174 C570 166 635 171 720 205" />
    <text className="chart-line-label chart-demand-label" x="555" y="126">Growth Opportunity</text>
    <line className="chart-label-rule chart-demand-rule" x1="574" y1="136" x2="604" y2="120" />
    <text className="chart-line-label chart-advantage-label" x="500" y="246">Competitive Advantage Resilience</text>
    <line className="chart-label-rule chart-advantage-rule" x1="548" y1="229" x2="592" y2="183" />
    <text className="chart-zone-label chart-supported-label" x="270" y="397">Growth Supported by Advantage</text>
    <text className="chart-zone-label chart-dilution-label" x="635" y="397">Increasing Dilution Risk</text>
    <text className="chart-pressure-zone-label" x="507" y="90" transform="rotate(-90 507 90)">Scalability Pressure Zone</text>
  </svg>
  <div className="concept-chart-legend" data-testid={`${testId}-legend`}>
    <p><span className="legend-line legend-demand" />Growth Opportunity</p>
    <p><span className="legend-line legend-advantage" />Competitive Advantage Resilience</p>
    <p><span className="legend-line legend-threshold" />Scalability Pressure Zone · Increasing Dilution Risk</p>
  </div>
  <figcaption data-testid={`${testId}-caption`}>Conceptual illustration only. The relationships shown are directional and do not represent empirical measurements, predetermined thresholds, or quantitative forecasts.</figcaption>
</figure>;

export const ConceptEquation = ({ testId }) => <figure className="concept-equation" aria-labelledby={`${testId}-title`} data-testid={testId}>
  <p className="equation-kicker" id={`${testId}-title`} data-testid={`${testId}-label`}>Conceptual relationship</p>
  <div className="equation-expression" role="math" aria-label="Growth Sustainability is proportional to Advantage Scalability divided by one plus Dilution Risk" data-testid={`${testId}-expression`}>
    <i>G</i><sub>s</sub><span>∝</span><span className="equation-fraction"><span><i>A</i><sub>s</sub></span><span>1 + <i>D</i><sub>r</sub></span></span>
  </div>
  <dl className="equation-definitions" data-testid={`${testId}-definitions`}>
    <div><dt><i>G</i><sub>s</sub></dt><dd>Growth Sustainability</dd></div>
    <div><dt><i>A</i><sub>s</sub></dt><dd>Advantage Scalability</dd></div>
    <div><dt><i>D</i><sub>r</sub></dt><dd>Dilution Risk</dd></div>
  </dl>
  <div className="equation-directions" aria-label="As Advantage Scalability rises, Growth Sustainability rises. As Dilution Risk rises, Growth Sustainability falls." data-testid={`${testId}-directions`}>
    <p><i>A</i><sub>s</sub> ↑ <span aria-hidden="true">→</span> <i>G</i><sub>s</sub> ↑</p>
    <p><i>D</i><sub>r</sub> ↑ <span aria-hidden="true">→</span> <i>G</i><sub>s</sub> ↓</p>
  </div>
</figure>;

export const FrameworkStages = ({ block, testId }) => <div className="framework-stages" aria-label="Four stages of the Growth–Advantage Framework" data-testid={testId}>
  {block.stages.map((stage, index) => <div className="framework-stage-wrap" key={stage.number}>
    <article className="framework-stage" data-testid={`${testId}-stage-${stage.number}`}>
      <p className="framework-stage-number">{stage.number} — {stage.label}</p>
      <h4>{stage.title}</h4>
      <p className="framework-stage-question">{stage.question}</p>
      {stage.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
      {stage.factors && <ul>{stage.factors.map((factor) => <li key={factor}>{factor}</li>)}</ul>}
      {stage.conclusion && <p>{stage.conclusion}</p>}
    </article>
    {index < block.stages.length - 1 && <div className="framework-stage-bridge" aria-hidden="true"><span>{stage.bridge}</span><b>↓</b></div>}
  </div>)}
</div>;

const matrixQuadrants = [
  {
    number: "01",
    position: "top-left",
    scalability: "Low Scalability",
    risk: "High Dilution Risk",
    response: "Protect the Advantage",
    logic: "Core capabilities are difficult to scale and expansion creates substantial dilution risk.",
    priority: "Preserve the sources of differentiation before pursuing further scale.",
  },
  {
    number: "02",
    position: "top-right",
    scalability: "High Scalability",
    risk: "High Dilution Risk",
    response: "Scale Selectively",
    logic: "Core capabilities can scale, but expansion still creates meaningful dilution risk.",
    priority: "Pursue growth selectively while controlling where dilution pressure emerges.",
  },
  {
    number: "03",
    position: "bottom-left",
    scalability: "Low Scalability",
    risk: "Low Dilution Risk",
    response: "Increase Scalability",
    logic: "Dilution risk is currently limited, but the capabilities supporting advantage remain difficult to scale.",
    priority: "Strengthen systems and capabilities before accelerating expansion.",
  },
  {
    number: "04",
    position: "bottom-right",
    scalability: "High Scalability",
    risk: "Low Dilution Risk",
    response: "Accelerate Growth",
    logic: "Core capabilities are scalable and dilution risk remains relatively limited.",
    priority: "The organisation has stronger conditions for pursuing expansion.",
  },
];

export const GrowthAdvantageMatrix = ({ testId }) => <figure className="framework-figure growth-matrix" aria-labelledby={`${testId}-title`} data-testid={testId}>
  <div className="framework-figure-heading">
    <span>Figure 02</span>
    <div><h3 id={`${testId}-title`}>The Growth–Advantage Framework</h3><p className="matrix-subtitle">Growth discipline depends on the scalability of competitive advantage and the risk that expansion dilutes it.</p></div>
  </div>
  <div className="matrix-decision-logic" aria-label="Advantage Scalability multiplied by Dilution Risk leads to Growth Discipline" data-testid={`${testId}-decision-logic`}><span>Advantage Scalability</span><b>×</b><span>Dilution Risk</span><b>→</b><strong>Growth Discipline</strong></div>
  <div className="matrix-mobile-orientation" aria-label="Dilution Risk ranges from low to high upward. Advantage Scalability ranges from low to high toward the right." data-testid={`${testId}-mobile-orientation`}>
    <p><span>Dilution Risk</span><b>High ↑</b></p>
    <p><span>Advantage Scalability</span><b>Low → High</b></p>
  </div>
  <div className="matrix-layout" role="group" aria-label="Qualitative two by two matrix. Advantage Scalability increases from low on the left to high on the right. Dilution Risk increases from low at the bottom to high at the top. Protect the Advantage is top left. Scale Selectively is top right. Increase Scalability is bottom left. Accelerate Growth is bottom right." data-testid={`${testId}-matrix`}>
    <div className="matrix-y-axis" aria-hidden="true"><span>High</span><p>Dilution Risk</p><i>↑</i><span>Low</span></div>
    <div className="matrix-grid">
      {matrixQuadrants.map((quadrant) => <section className={`matrix-quadrant matrix-${quadrant.position}`} key={quadrant.position} data-testid={`${testId}-${quadrant.position}`}>
        <p className="matrix-mobile-number" aria-hidden="true">{quadrant.number}</p>
        <p className="matrix-coordinates" data-testid={`${testId}-${quadrant.position}-coordinates`}><span>{quadrant.scalability}</span><span>{quadrant.risk}</span></p>
        <h4 data-testid={`${testId}-${quadrant.position}-response`}>{quadrant.response}</h4>
        <p className="matrix-rationale" data-testid={`${testId}-${quadrant.position}-rationale`}>{quadrant.logic}</p>
        <p className="matrix-priority" data-testid={`${testId}-${quadrant.position}-priority`}><span>Strategic priority</span>{quadrant.priority}</p>
      </section>)}
    </div>
    <div className="matrix-x-axis" aria-hidden="true"><span>Low</span><p>Advantage Scalability <i>→</i></p><span>High</span></div>
  </div>
  <figcaption data-testid={`${testId}-caption`}>Qualitative strategic framework only. The matrix does not represent quantitative scoring, empirically fixed thresholds, permanent company classifications or forecasts of business performance.</figcaption>
</figure>;

export const FrameworkSteps = ({ block, testId }) => <ol className="framework-steps" data-testid={testId}>
  {block.items.map((item, index) => <li key={item.title} data-testid={`${testId}-step-${index + 1}`}>
    <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
    <div><h3>{item.title}</h3><p>{item.text}</p></div>
  </li>)}
</ol>;
